<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        <div class="results-prizes-block-images">
            <div class="results-prizes-shape">
                <img [attr.src]="vm.resultsPrize.backGroundShapeImage?.src" />
            </div>
            <div class="results-prizes-confetti" [style.background-image]="'url(' + vm.resultsPrize.confettiImage?.src + ')'">
                <img class="results-prizes-cup" [attr.src]="vm.resultsPrize.prizeCupImage?.src" />
            </div>
        </div>
        <div class="results-prizes-block-content">
            <div class="results-prizes-title text-truncate" [vnDynamicHtml]="vm.resultsPrize.title"></div>
            @if (vm.resultsPrize.creditOn) {
                <div class="results-prizes-crediton text-truncate">
                    {{ vm.resultsPrize.creditOn }}
                </div>
            }
            @if (vm.showCheckButton && vm.resultsPrize.isSuccessfullyAwarded && vm.resultsPrize.showCta) {
                <a
                    [attr.href]="vm.resultsPrize.checkPromoLink?.url"
                    target="{{ !!vm.resultsPrize.checkPromoLink?.attributes?.target ? vm.resultsPrize.checkPromoLink?.attributes?.target : '' }}"
                    [onClickWebTracker]="{
                        LabelEvent: vm.webAnalytic.page,
                        ActionEvent: 'View Prize  - Click',
                        LocationEvent: vm.webAnalytic.tab,
                        EventDetails: vm.webAnalytic.promoId,
                        campaignId: vm.webAnalytic.campaignId,
                        messageType: vm.webAnalytic.messageType,
                    }"
                    (click)="checkButtonClick(); $event.preventDefault()"
                    class="btn btn-primary btn-sm"
                    >{{ !!vm.resultsPrize.checkPromoLink?.text ? vm.resultsPrize.checkPromoLink.text : vm.commonContentMessages?.check }}</a
                >
            }
            <span>
                @if (!vm.resultsPrize.isSuccessfullyAwarded) {
                    <i
                        class="ui-icon theme-info-i"
                        [closeOnInteraction]="true"
                        [closeOutsideViewport]="true"
                        [closeOnScroll]="true"
                        [dsTooltipTriggerFor]="popperContent"
                        arrowPosition="middle"
                        position="bottom"></i>
                    <ng-template #popperContent>
                        <ds-tooltip-content variant="{{ dsComponents?.dsTooltip?.variant }}" inverse="{{ dsComponents?.dsTooltip?.inverse }}">
                            <button
                                slot="close"
                                ds-button-icon
                                size="small"
                                variant="flat"
                                kind="{{ dsComponents?.dsTooltip?.iconButtonKind }}"
                                inverse="{{ dsComponents?.dsTooltip?.iconButtonInverse }}">
                                <vn-icon slot="close" size="10" name="theme-ex"></vn-icon>
                            </button>
                            <div slot="title" [innerHtml]="vm.commonContentMessages?.poppertitle"></div>
                            <div slot="description" [innerHtml]="vm.commonContentMessages?.popperdescription"></div>
                        </ds-tooltip-content>
                    </ng-template>
                }
            </span>
        </div>
    }
</ng-container>
